function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage8JobSearchResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 44 44)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 14.45 28.92)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(129,207,78)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-58.45, -72.92)",
    d: "M 83.9893 72.9175 C 83.9893 79.0268 79.0161 84 72.9068 84 C 72.5209 84 72.1458 83.9786 71.7707 83.9464 C 65.3827 83.3676 62.7567 78.0514 58.4481 78.0514 C 54.1394 78.0514 51.5134 83.3569 45.1255 83.9464 C 44.7503 83.9893 44.3752 84 43.9893 84 C 37.88 84 32.9068 79.0268 32.9068 72.9175 C 32.9068 66.8081 37.88 61.8349 43.9893 61.8349 C 51.2241 61.8349 53.8929 67.7942 58.4481 67.7942 C 63.0033 67.7942 65.6828 61.8349 72.9068 61.8349 C 79.0161 61.8349 83.9893 66.8082 83.9893 72.9175 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -28.93 14.46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(40,88,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-15.07, -58.46)",
    d: "M 15.0719 84 C 8.96257 84 3.98937 79.0268 3.98937 72.9175 C 3.98937 72.5316 4.01081 72.1565 4.04297 71.7814 C 4.62174 65.3934 9.93793 62.7674 9.93793 58.4587 C 9.93793 54.1501 4.62174 51.5241 4.04297 45.1361 C 4.0001 44.761 3.98937 44.3859 3.98937 44 C 3.98937 37.8907 8.96257 32.9175 15.0719 32.9175 C 21.1812 32.9175 26.1544 37.8907 26.1544 44 C 26.1544 51.2347 20.1952 53.9035 20.1952 58.4587 C 20.1952 63.0139 26.1544 65.6935 26.1544 72.9175 C 26.1544 79.0268 21.1812 84 15.0719 84 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.01 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(129,207,78)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-43.99, -44)",
    d: "M 43.9893 55.0825 C 50.0986 55.0825 55.0718 50.1093 55.0718 44 C 55.0718 37.8907 50.0986 32.9175 43.9893 32.9175 C 37.8799 32.9175 32.9067 37.8907 32.9067 44 C 32.9067 50.1093 37.8799 55.0825 43.9893 55.0825 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.01 -14.46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(129,207,78)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-43.99, -29.54)",
    d: "M 15.0718 26.1651 C 15.2648 26.1651 15.447 26.1436 15.6399 26.1329 C 15.8328 26.1329 16.015 26.1329 16.208 26.1007 C 22.596 25.522 25.2326 20.2058 29.5306 20.2058 C 33.8285 20.2058 36.4652 25.522 42.8532 26.1007 C 43.0354 26.1222 43.2283 26.1222 43.4212 26.1329 C 43.6142 26.1329 43.7964 26.1651 43.9893 26.1651 C 44.3752 26.1651 44.7503 26.1436 45.1254 26.1115 C 51.5134 25.5327 54.1394 20.2165 58.448 20.2165 C 60.7524 20.2165 62.5745 21.7385 64.7503 23.2497 C 66.2615 25.4255 67.7835 27.2476 67.7835 29.552 C 67.7835 33.8607 62.4673 36.4866 61.8885 42.8746 C 61.8671 43.0568 61.8671 43.2497 61.8564 43.4319 C 61.8564 43.6249 61.8242 43.8071 61.8242 44 C 61.8242 50.1093 66.7974 55.0825 72.9068 55.0825 C 79.0161 55.0825 83.9893 50.1093 83.9893 44 C 83.9893 43.7963 83.9678 43.6141 83.9571 43.4319 C 83.9571 43.2497 83.9571 43.0568 83.925 42.8746 C 83.3462 36.4866 78.03 33.8499 78.03 29.552 C 78.03 25.254 83.3462 22.6066 83.9357 16.2187 C 83.9571 16.0364 83.9571 15.8435 83.9678 15.6506 C 83.9678 15.4577 84 15.2755 84 15.0825 C 83.9893 8.97321 79.0161 4.00001 72.9068 4.00001 C 65.672 4.00001 63.0032 9.95927 58.448 9.95927 C 53.8928 9.95927 51.2133 4.00001 43.9893 4.00001 C 43.7964 4.00001 43.6142 4.02144 43.4212 4.03216 C 43.2283 4.03216 43.0461 4.03216 42.8532 4.06431 C 36.4652 4.64309 33.8285 9.95927 29.5306 9.95927 C 25.2326 9.95927 22.596 4.64309 16.208 4.06431 C 16.0258 4.04287 15.8328 4.04287 15.6399 4.03216 C 15.447 4.03216 15.2648 4 15.0718 4 C 8.96252 4 3.98932 8.9732 3.98932 15.0825 C 3.98932 21.1918 8.96252 26.1651 15.0718 26.1651 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage8JobSearchResult);
export default __webpack_public_path__ + "static/media/image8 JobSearchResult.e7ceed691b9973a54a9983ab45a49738.svg";
export { ForwardRef as ReactComponent };